import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import React from "react";
import { ParamsWatcher } from "./components/ParamsWatcher";
import { SectionDescriptionDetail } from "./components/SectionDescriptionDetail";
import { SegmentsSection } from "./components/SegmentsSection";

export const SupervisorDocumentShow: React.FC = () => {
  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "Supervisión" : ""}
              defaultHref="/app/supervision"
              color="light"
            />
          </IonButtons>
          <IonTitle>Acuerdo</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className={isPlatform("desktop") ? "ion-padding" : ""}>
        <ParamsWatcher />
        <SectionDescriptionDetail />
        <SegmentsSection />
      </IonContent>
    </IonPage>
  );
};
